module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag34_1676AT.c30210ce.jpg";